/**
 * Tells whether a product's ad_label string represents an affirmative "Yes/Sí".
 * The DB stores ad_label as a free-form string with values like "", "NO", "SI", "ASK"...
 * Anything truthy that isn't an affirmative should be treated as "No" in the UI.
 */
export const isAdLabelYes = (value) => {
  if (!value) return false;
  const s = String(value).trim().toUpperCase();
  return ['SI', 'SÍ', 'YES', 'Y', 'S'].includes(s);
};
